import { Api, AuditEntity, Display, FormField, prop } from '@messaia/cdk';

/**
 * @class AdvertisingConsent
 * @description Represents a user's consent for receiving advertising communications through various channels.
 */
@Api('advertisingConsent')
export class AdvertisingConsent extends AuditEntity {
    /**
     * @property General advertising consent.
     * @type {boolean}
     */
    @prop()
    @FormField({
        row: 1,
        flex: 30,
        readonly: (x, f) => !x.isGranted && f?.get('isGranted')?.pristine === true
    })
    @Display($localize`:@@isGranted:Advertising Consent Granted`)
    public isGranted: boolean = false;

    /**
     * @property Consent granted via online channels.
     * @type {boolean}
     */
    @prop()
    @FormField({
        row: 1,
        flex: 70,
        readonly: x => true
    })
    @Display($localize`:@@isOnlineGranted:Online Advertising Consent Granted`)
    public isOnlineGranted: boolean = false;

    /**
     * @property Consent for all available advertising channels.
     * @type {boolean}
     */
    @prop()
    @FormField({ row: 10 })
    @Display($localize`:@@all:All Channels`)
    public all: boolean = false;

    /**
     * @property Consent for advertising via email.
     * @type {boolean}
     */
    @prop()
    @FormField({ row: 20, flex: 30 })
    @Display($localize`:@@email:Email`)
    public email: boolean = false;

    /**
     * @property Consent for advertising via WhatsApp.
     * @type {boolean}
     */
    @prop()
    @FormField({ row: 20, flex: 70 })
    @Display($localize`:@@whatsApp:WhatsApp`)
    public whatsApp: boolean = false;

    /**
     * @property Consent for advertising via phone calls.
     * @type {boolean}
     */
    @prop()
    @FormField({ row: 30, flex: 30 })
    @Display($localize`:@@phone:Phone`)
    public phone: boolean = false;

    /**
     * @property Consent for advertising via postal mail.
     * @type {boolean}
     */
    @prop()
    @FormField({ row: 30, flex: 70 })
    @Display($localize`:@@post:Post`)
    public post: boolean = false;

    /**
     * @property Marketing campaign associated with the consent, if any.
     * @type {boolean}
     */
    @prop()
    @FormField({ row: 40, flex: 30 })
    @Display($localize`:@@marketingCampaign:Marketing Campaign`)
    public marketingCampaign?: string;

    /**
     * Constructor for AdvertisingConsent.
     * @param init 
     */
    public constructor(init?: Partial<AdvertisingConsent>) {
        super();
        Object.assign(this, init);
    }
}